module.exports = __webpack_public_path__ + "img/1545719769.53d17a42.jpg";